<template>
    <v-card  height="100%">
        <DlgMessage ref="dlgMsg" @dlgClose="dlgClose"></DlgMessage>

        <div class="pa-3">
            <v-toolbar>
            <v-toolbar-title>{{this.logDetail.name}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-breadcrumbs :items="items"></v-breadcrumbs>
            </v-toolbar>
        </div>
<div class="pa-3">
            <v-card>
                <v-form ref="formSearch">
            <v-row class="mx-1">
                <v-col cols="12" md="4">
                    <v-select
                        v-model="form.search_key"
                        :items="searchKeyList"
                        item-text="description"
                        item-value="code"
                        label="Search Key"
                        standard
                        outlined
                        dense
                        @change="getIndex"
                    ></v-select>
                </v-col>

                
                <v-col cols="12" md="4">
                    <template v-if="searchKeyList[searchKeyIndex]['type'] == 'string'">
                    <v-text-field
                        v-model="form.search_word"
                        label="Search Word"
                        outlined
                        dense
                        clearable
                        :rules="[rules.required, rules.counter]"
                    ></v-text-field>
                    </template>
                    <template v-else>

                            <v-menu v-model="dpicker.menu1" :close-on-content-click="false" max-width="290">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        outlined
                                        dense
                                        :value="form.date_from"
                                        label="Date From"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="form.date_from" @change="dpicker.menu1 = false"></v-date-picker>
                            </v-menu>
                            <v-menu v-model="dpicker.menu2" :close-on-content-click="false" max-width="290">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        outlined
                                        dense
                                        :value="form.date_to"
                                        label="Date To"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="form.date_to" @change="dpicker.menu2 = false"></v-date-picker>
                            </v-menu>
                    </template>

                </v-col>
                <v-col cols="12" md="3">
                    <v-select
                        v-model="form.data_limit"
                        :items="dataLimitList"
                        item-text="description"
                        item-value="code"
                        label="Data Limit"
                        standard
                        outlined
                        dense
                    ></v-select>
                </v-col>
                <v-col cols="12" md="1">
                    <v-btn icon condensed color="panel1" @click="refreshDataTable">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                </v-col>
                
            </v-row>
                </v-form>
            </v-card>
        </div>        
        <div class="pa-3">
        <v-card>
        <v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon dark class="primary mr-2" @click="refreshDataTable"><v-icon>mdi-refresh</v-icon></v-btn>         
        </v-card-title>
        <v-card-text>

        <v-text-field
            v-model="tblSearch"
            append-icon="mdi-magnify"
            label="Search data below"
            hide-details
            outlined
        ></v-text-field>
        </v-card-text>

        <v-data-table
        v-model="selected"  
        ref="vuetable"
        :headers="tblHeaders"
        :items="tblBody"
        :search="tblSearch"
        :loading = "loadingFlag"
        loading-text="Loading... Please wait"    
        ></v-data-table>
        </v-card>
        </div>

    </v-card>

</template>
<script>
//import axios from 'axios';
import moment from 'moment'
import DlgMessage from '@/components/DlgMessage'
import ApLogService from "@/services/ApLogService"
export default {
    components:{DlgMessage},
    props: {
       caller: String
    },
    data() {
        return{
            //breadcrumb
            items: [
              {text:'Log',disabled: false,href:'/',},
              {text:'List',disabled: false,href:'#',},
              {text:'View',disabled: false,href:'#',},
              ],
            selected: [],
            tblHeaders:[],
            tblBody:[],
            tblSearch:'',
            loadingFlag : false,
            errorFlag : false,
            visible:false,
            routeType:"",
            logDetail:{name:""},
            form:{
                log_for:"",
                search_key:"created_date",
                search_word:"",
                start_date:"",
                end_date:"",
                data_limit:500
            },
            cpFiles:{
                file_type:'excel',
                route_type:'member_registration',
                showDialog:false,
            },
            routeParam:[],
            searchKeyIndex:0,
            searchKeyList:[
                {code:'created_date',description:'Created Date',type:'date'},
            ],
            dataLimit:500,
            dataLimitList:[
                {code:500,description:'500 rows'},
                {code:1000,description:'1000 rows'},
                {code:2000,description:'2000 rows'},
                {code:5000,description:'5000 rows'},
            ],
            dpicker:{menu1: false,menu2: false,},



        }
    },
    async created() {  
        this.form.log_for = this.$route.params.log_for;
        this.form.date_from = moment(String(new Date())).format('YYYY-MM-01');
        this.form.date_to = moment(String(new Date())).format('YYYY-MM-DD');

        this.refreshDataTable();
    },
    mounted(){
        
    },
    watch:{
        "$route.params.log_for":{
            handler:function(value){
                this.form.log_for = value;
                this.refreshDataTable();
                //console.log(value);
            },
            deep:true,
            immediate:true,
        }
    },
    // beforeRouteEnter(to,from){
    //     //console.log("to",to.params.log_for)
    //     //console.log("from",from.params.log_for)
    //     this.form.log_for = to.params.log_for;
    //     this.refreshDataTable();
    //     //console.log(to.params.log_for);

    // },    
    // beforeRouteUpdate(to,from){
    //     //console.log("to",to.params.log_for)
    //     //console.log("from",from.params.log_for)
    //     this.form.log_for = to.params.log_for;
    //     this.refreshDataTable();
    //     //console.log(to.params.log_for);

    // },
    methods:{
            async refreshDataTable(){
                this.loadingFlag = true;
                if(!this.form.date_from)
                    this.form.date_from = moment(String(new Date())).format('YYYY-MM-01');
                if(!this.form.date_to)
                    this.form.date_to = moment(String(new Date())).format('YYYY-MM-DD');

                try{
                    ApLogService.list_log(this.form).then((res) => {
                        //console.log(res);
                        this.tblBody = res.data.data;
                        this.logDetail = res.data.logDetail;

                        if(res.data.data.length>0){
                            this.tblHeaders = [];
                            let keys = Object.keys(res.data.data[0]);
                            for(let key=0;key<=keys.length;key++){
                                let tmp = {text:keys[key],value:keys[key]}
                                this.tblHeaders.push(tmp);
                            }
                        }
                        this.loadingFlag = false;
                        this.errorFlag = false;
                    }).catch((e)=>{
                        //console.log('e content:',e);
                        this.$refs.dlgMsg.showDlgBox(true,'error','Log',e);
                        this.loadingFlag = false
                        this.errorFlag = true;
                    })
                    ;
                } catch(e) {
                    this.loadingFlag = false
                    this.$refs.dlgMsg.showDlgBox(true,'error','Log','Unknown Error');
                  
                }           
            },
        dlgClose(){
            this.visible = false;        
        },
        getIndex(e){
            this.searchKeyIndex = this.searchKeyList.map(function (key) { return key.code; }).indexOf(e);
        },



    }

}
</script>